import React from 'react';
import { useParams } from 'react-router-dom';
import { Heading } from '@mm/components';
import { ReactComponent as MigrateToIcImage } from 'assets/migrate-to-ic-banner.svg';
import { useChatbotCRUDActions } from '@mm/state/actions/ChatbotCRUDActions';
import { useSelector, useDispatch } from 'react-redux';
import modalActions, {
  useModalActions,
} from '@mm/state/modules/modalsState/actions';
import { defaultInstachampPlanSelector } from '@mm/state/selectors/subscriptionSelectors';
import { useSubscriptionCRUDActions } from '@mm/state/actions/SubscriptionCRUDActions';
import { EnhancedBillingPage } from '@mm/state/interfaces/connected-page';
import styles from './MigrateToInstachampBanner.module.css';
import { PrimaryButton } from '../../../../../../common/buttons/PrimaryButton/PrimaryButton';
import { useMigrateToInstachampRedirectCallback } from '../../../../../../common/hooks/use-migrate-to-instachamp-redirect-callback';

type Props = {
  page?: EnhancedBillingPage;
  subscriptionId: number;
  companyId: number;
};

export const MigrateToInstachampBanner = (props: Props) => {
  const { page, subscriptionId, companyId } = props;
  const chatbotCRUDActions = useChatbotCRUDActions();
  const subscriptionCRUDActions = useSubscriptionCRUDActions();
  const { openMigrateToInstachampThanksModal } = useModalActions();
  const defaultInstachampPlan = useSelector(
    defaultInstachampPlanSelector,
  )?.planCode;
  const redirectToInstachamp = useMigrateToInstachampRedirectCallback();
  const { pageId } = useParams<{ pageId: string }>();
  const dispatch = useDispatch();

  const name = 'Instachamp Bot';

  const onSuccessBilling = async () => {
    if (page) {
      const bot = await chatbotCRUDActions.create({
        name,
        companyId,
        facebookPageId: page.id || Number(pageId),
      });
      if (bot) {
        await chatbotCRUDActions.attachToFacebookPage(bot.bot.id, page.id);
        dispatch(modalActions.closeModal());
        redirectToInstachamp();
      }
    }
  };

  const onConfirmHandler = async () => {
    const res = await subscriptionCRUDActions.downgrade(
      companyId,
      subscriptionId,
      {
        planCode: defaultInstachampPlan,
        facebookPageId: page?.id || Number(pageId),
        companyId,
        pollResults: {},
      },
    );
    if (res) {
      onSuccessBilling();
    }
  };

  const onMigrateClick = async () => {
    if (page && companyId) {
      if (subscriptionId && defaultInstachampPlan) {
        openMigrateToInstachampThanksModal({
          onConfirmHandler,
        });
      }
    }
  };

  return (
    <div className={styles.banner}>
      <div className={styles.quote}>
        <div>
          These are the game-changing new tools I use to grow and automatically
          engage with my Instagram followers.
        </div>
        <div className={styles.textContainer}>
          <span className={styles.boldText}>SORAV JAIN</span>
          <span className={styles.regularText}>
            Sorav | INSTAGRAM INFLUENCER
          </span>
        </div>
      </div>
      <MigrateToIcImage />
      <div className={styles.description}>
        <Heading size={3}>How about a fresh start?</Heading>
        <div className={styles.subHeader}>
          InstaChamp is an easy to use platform for SMBs and creators
        </div>
        <ul className={styles.list}>
          <li>Great value! $9.95 per month </li>
          <li>Easy to use Autoresponders for Instagram and Facebook</li>
        </ul>
        <PrimaryButton color="green" onClick={onMigrateClick}>
          Move my Account to InstaChamp
        </PrimaryButton>
      </div>
    </div>
  );
};
